import React from "react";
import classNames from "classnames";
import CommonButton from "@components/CommonButton";
import { IconArrow } from "@icons/index";
import "./index.scss";
import { Trans } from "react-i18next";

export interface StepItem {
  key: string;
  title: string;
}

export interface StepProgressProps {
  className?: string;
  steps: StepItem[];
  current: number;
  onChange?: (step: number) => void;
  /** 禁止跳转到的步骤索引数组 */
  disabledSteps?: number[];
  /** 禁用返回按钮 */
  disabledBack?: boolean;
}

export const StepProgress: React.FC<StepProgressProps> = ({
  className,
  steps,
  current,
  onChange,
  disabledSteps = [],
  disabledBack = false,
}) => {
  const isStepDisabled = (index: number) => disabledSteps.includes(index);

  const handleBack = () => {
    onChange?.(current - 1);
  };

  return (
    <div className={classNames("flex items-center justify-between", className)}>
      <div className="w-[32px] h-[32px]">
        {current !== 0 && (
          <CommonButton onClick={handleBack} disabled={disabledBack} className="w-[32px] h-[32px] p-0">
            <IconArrow className="w-[24px] h-[24px] shrink-0" />
          </CommonButton>
        )}
      </div>
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const disabled = index > current && isStepDisabled(index);
          return (
            <React.Fragment key={step.key}>
              <div
                className={classNames(
                  "step-item",
                  index === current && "step-item--active",
                  disabled && "step-item--disabled",
                )}
                // onClick={() => handleStepClick(index)}
              >
                <div className="step-item__circle">{index + 1}</div>
                <span className="step-item__title">
                  <Trans>{step.title}</Trans>
                </span>
              </div>
              {index < steps.length - 1 && <div className="step-item__connector" />}
            </React.Fragment>
          );
        })}
      </div>
      <div className="w-[32px] h-[32px]">
        {/* <CommonButton
          onClick={handleForward}
          disabled={isForwardDisabled}
          className={classNames("w-[32px] h-[32px] p-0", isForwardDisabled && "opacity-50 cursor-not-allowed")}
        >
          <IconArrow className="w-[24px] h-[24px] shrink-0 rotate-180" />
        </CommonButton> */}
      </div>
    </div>
  );
};

export default StepProgress;
